import { Grid, GridProps, styled } from "@mui/material";

type MxCPropertyContentProps = GridProps
const MxCPropertyContent = (props: MxCPropertyContentProps) => {
  return <Content {...props} />;
};

export default MxCPropertyContent;

const Content = styled(Grid)(({ theme }) => ({
  position: "relative",
  width: "100%",
  minWidth: 270,
  height: "auto",
  minHeight: 260,
  background: "white",
  borderRadius: 15,
  transition: "box-shadow 0.3s ease-in-out",
  boxShadow:
    "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",

  "&:hover": {
    boxShadow:
      "rgba(0,46, 124,  0.4) 0px 2px 5px -1px, rgba(0, 46, 124, 0.6) 0px 1px 10px -1px;"
  },
  "&:hover .checkbox-container .MuiButtonBase-root": {
    display: "flex"
  }
}));
